import { css } from 'styled-components';
export default {
    lato: {
        regular: css `
      font-family: 'Lato', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'Lato', sans-serif;
      font-weight: 400;
      font-style: italic;
    `,
        semiBold: css `
      font-family: 'Lato', sans-serif;
      font-style: normal;
      font-weight: 600;
    `,
        semiBoldItalic: css `
      font-family: 'Lato', sans-serif;
      font-weight: 600;
      font-style: italic;
    `,
        bold: css `
      font-family: 'Lato', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: 'Lato', sans-serif;
      font-weight: 700;
      font-style: italic;
    `,
    },
    intro: css `
    font-family: 'Intro', serif;
    font-style: normal;
    font-weight: 600;
  `,
};
